import { useState } from "react";
import "../styles/Login.scss";
import logo from "../assets/logoWithName1.png";
import CommonInput from "../components/common/CommonInput";
import { FaPhoneAlt, FaEyeSlash, FaEye } from "react-icons/fa";
import { MdLock } from "react-icons/md";
import CommonButton from "../components/common/CommonButton";
import ConfirmModal from "../components/common/ConfirmModal";
import { Box, Button, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useLogin from "../components/common/useLogin";
import { APIGenerateOTP, APIValidateOTP } from "../helper/apiUrls";
import { apiPost, buildQueryString, indianMobileFilter } from "../helper/utils";
import { useSetAtom } from "jotai";
import { alertAtom, globalLoaderAtom } from "../jotaiState/globalStateAtoms";
const Login = () => {
  const navigate = useNavigate();
  const setAlert = useSetAtom(alertAtom);
  const setLoader = useSetAtom(globalLoaderAtom);

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [MobileNo, setMobileNo] = useState("");
  const [optSent, setOptSent] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const { setLogin } = useLogin();

  const handleOTPSend = (isResend = false) => {
     if (!MobileNo) {
      setAlert({
        show: true,
        msg: "Please enter mobile number",
        nextId: "",
      });
      return;
    }

    if (MobileNo.length !== 10) {
      setAlert({
        show: true,
        msg: "Mobile number should be 10 digits",
        nextId: "",
      });
      return;
    }
    setLoader(true);
    apiPost(APIGenerateOTP + "?" + buildQueryString({ MobileNo }))
      .then((res) => {
        if (!res.IsSuccess) {
          throw new Error(res.ErrorMessage || "Error fetching OTP");
        }
        const data = JSON.parse(res.Data);
        setCompanyId(data[0].CompanyId);
        setOptSent(true);
        setAlert({ show: true, msg: isResend ? 'OTP Resent Successfully!' : 'OTP Sent Successfully!', nextId: "" });
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: "" });
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleLogin = () => {
   
    if (!agreeTerms) {
      setOpenModal(true);
      return;
    }


    const payload = {
      strOTPType: "OD",
      MobileNo,
      intOTP: otp,
      intCompanyId: companyId,
    };
    apiPost(APIValidateOTP + "?" + buildQueryString(payload))
      .then((res) => {
        if (!res.status) {
          throw new Error(res.Message || "Error fetching OTP");
        }
        const data = JSON.parse(res.Data);
        if (data.length === 0) {
          throw new Error("Invalid OTP");
        }
        setLogin(data[0]);
        navigate("/assigned-trips", { replace: true });
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: "" });
      });
  };
  return (
    <div className="login-container">
      <img src={logo} alt="Company Logo" className="logo" />
      <div className="logo-separator"></div>
      <h1 className="title">DRIVER APP</h1>

      <CommonInput
        label="Mobile Number"
        type="tel"
        placeholder="Enter mobile number"
        icon={<FaPhoneAlt />}
        deferred={true}
        filter={indianMobileFilter}
        maxLength={10}
        value={MobileNo}
        onChange={(e) => setMobileNo(e.target.value)}
      />

      <CommonButton type="primary" disabled={optSent} onClick={() => handleOTPSend(false)}>
        Get OTP
      </CommonButton>
      <CommonInput
        label="One Time Password (OTP)"
        type={showOtp ? "text" : "password"}
        value={otp}
        icon={<MdLock />}
        rightIcon={showOtp ? <FaEyeSlash /> : <FaEye />}
        onRightIconClick={() => setShowOtp(!showOtp)}
        iconSize={"22px"}
        onChange={(e) => setOtp(e.target.value)}
      />

      <CommonButton type="primary" disabled={!optSent} onClick={handleLogin}>
        Login
      </CommonButton>

      <Button disabled={!optSent} onClick={() => handleOTPSend(true)}>
        Resend OTP
      </Button>
      <label className="terms">
        <Box className="commonCheckBox">
          <Checkbox
            checked={agreeTerms}
            onChange={(e) => setAgreeTerms(e.target.checked)}
          />
        </Box>

        <span>
          I agree to MavenTech{" "}
          <span
            className="highlight"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open("http://buscrs.com/terms_of_use", "_blank", "noopener,noreferrer");
            }}
            style={{ cursor: "pointer" }}
          >
            Terms & Conditions
          </span>{" "}
          and{" "}
          <span
            className="highlight"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open("http://buscrs.com/privacy_policy", "_blank", "noopener,noreferrer");
            }}
            style={{ cursor: "pointer" }}
          >
            Privacy Policy
          </span>
        </span>
      </label>

      <ConfirmModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        msg={
          <>
            You need to agree to MavenTech{" "}
            <span
              style={{
                color: "#004F9E",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open("http://buscrs.com/terms_of_use", "_blank", "noopener,noreferrer");
              }}
            >
              Terms & Conditions
            </span>{" "}
            and{" "}
            <span
              style={{
                color: "#004F9E",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open("http://buscrs.com/privacy_policy", "_blank", "noopener,noreferrer");
              }}
            >
              Privacy Policy
            </span>
          </>
        }

        btnCancel="Don't Agree"
        BtnConfirm="Agree"
        handleCancel={() => {
          setOpenModal(false);
        }}
        handleConfirm={() => {
          setAgreeTerms(true);
          setOpenModal(false);
        }}
      />
    </div>
  );
};

export default Login;
